import { useUserQuery } from 'api/user/queries'

import { isDocumentAnalysis } from 'consts/documentAnalysisModes'

export const useAvailableDocumentAnalysisModes = () => {
  const { data, isPending } = useUserQuery({
    select: ({ user: { agentModes } }) => agentModes?.filter(isDocumentAnalysis),
  })

  return {
    availableDocumentAnalysisModes: data || [],
    isPending,
  }
}
